import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { PRD1020_R01Dto } from "./Dto_PRD1020_R01";
import { PRD1020_R01Filter } from "./Store_PRD1020_R01";

const baseUrl = `${config.apiUrl}/PRD1020_R01`;

/**
 * 화면 Store의 검색조건을 조회·엑셀 API가 공통으로 사용하는 Query Parameter로 변환한다.
 * 선택형 조건의 빈 문자열은 undefined로 바꿔 요청 URL에서 제외하고,
 * 필수 기준인 생산년월은 YYYY-MM 형식 그대로 백엔드에 전달한다.
 * itemNm은 품목코드 옆 표시용 값이므로 서버 조회조건에는 포함하지 않는다.
 */
const getParams = (filter: PRD1020_R01Filter) => ({
	compCd: filter.compCd || undefined,
	yearMonth: filter.yearMonth,
	brandCd: filter.brandCd || undefined,
	itemGroup: filter.itemGroup || undefined,
	itemAccount: filter.itemAccount || undefined,
	itemCd: filter.itemCd || undefined,
});

/** 현재 검색조건에 맞는 생산계획 대비 실적 병합 목록을 조회한다. */
export const getPRD1020_R01List = (filter: PRD1020_R01Filter) =>
	getData<ResponseDto<PRD1020_R01Dto[]>>(`${baseUrl}/search`, {
		params: getParams(filter),
	});

/** 화면 조회와 동일한 검색조건으로 서버 생성 엑셀 데이터를 요청한다. */
export const downloadExcel_PRD1020_R01 = (filter: PRD1020_R01Filter) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel/search`, {
		params: getParams(filter),
	});
